import type { RouteConfig } from './index';

export function resolveFullPath(parentPath: string, routePath: string) {
  let fullPath = routePath;

  if (parentPath && !routePath.startsWith('/')) {
    fullPath = `${parentPath}/${routePath}`;
  } else if (!routePath.startsWith('/') && routePath !== '') {
    fullPath = `/${routePath}`;
  }

  return fullPath.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
}

export type RouteWithFullPath = Omit<RouteConfig, 'children'> & {
  fullPath: string;
  children?: RouteWithFullPath[];
};

export function mapRoutesWithFullPath(
  routeConfigs: RouteConfig[],
  parentPath = ''
): RouteWithFullPath[] {
  return routeConfigs.map((route) => {
    const fullPath = resolveFullPath(parentPath, route.path);
    const { children, ...rest } = route;
    const next: RouteWithFullPath = {
      ...rest,
      fullPath,
    };

    if (children && children.length > 0) {
      next.children = mapRoutesWithFullPath(children, fullPath);
    }

    return next;
  });
}
